import { FC } from 'react';

import { Link, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    vacancyInfo: 'CampaignCreationWizard.PromotionTypeStep.vacancyInfo',
    vacancyIdOnly: 'CampaignCreationWizard.PromotionTypeStep.vacancyIdOnly',
};

interface VacancyLinkProps {
    dataQa: string;
    vacancyId: number | string;
    vacancyName?: string | null;
    onClick?: () => void;
}

export const VacancyLink: FC<VacancyLinkProps> = ({ dataQa, vacancyId, vacancyName, onClick }) => {
    const trl = useTrls();

    return (
        <Link href={`https://hh.ru/vacancy/${vacancyId}`} target="_blank" data-qa={dataQa} onClick={onClick}>
            <Text Element="span" typography="paragraph-1-regular" style="accent">
                {vacancyName
                    ? trl(TrlKeys.vacancyInfo, [vacancyName, vacancyId])
                    : trl(TrlKeys.vacancyIdOnly, [vacancyId])}
            </Text>
        </Link>
    );
};
